import { IS_WHITE_LABEL } from '@/shared/environments';
import { isTrackingDisabled } from '@/shared/lib/isTrackingDisabled';

export const isExcludedFromTrialPaywall = () => IS_WHITE_LABEL || isTrackingDisabled();
